import { useState, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { createTechnician } from '../../api/technicians';

import Input from '../../components/input/input';
import Textarea from '../../components/textarea/textarea';
import Select from '../../components/select/select';

import { ReactComponent as ArrowRightSVG } from '../../icons/arrow-right.svg';

import { COUNTRIES } from '../../config/country';

const TechnicianAdd = () => {
  const [loading, setLoading] = useState(false);
  const [technician, setTechnician] = useState({});
  const history = useHistory();

  const onChange = (e) => {
    const { name, value } = e.target;

    setTechnician({
      ...technician,
      [name]: value,
    });
  };

  const onSelectChange = (field, selectedOption) => {
    setTechnician({
      ...technician,
      [field]: selectedOption,
    });
  };

  const onSubmit = useCallback(async () => {
    setLoading(true);

    const newTechnician = await createTechnician({
      ...technician,
      country: technician.country && technician.country.value,
    });

    history.push(`/technicians/${newTechnician.id}`);
  }, [history, technician]);

  if (loading) return <main className="th-main"></main>;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header">
          <h2 className="th-canvas-title">
            <Link to="/technicians">Technicians</Link>
            <span>
              <ArrowRightSVG />
            </span>
            Add
          </h2>
          <section className="view-actions">
            <button className="btn-green" data-cy="submit" onClick={onSubmit}>
              Submit
            </button>
          </section>
        </header>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">Details</h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
            <div className="w-100 flex flex-column">
              <div className="w-100 flex flex-row items-start justify-between margin-between">
                <div className="w-66">
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Input
                        name="firstName"
                        label="First name*"
                        value={technician.firstName}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="lastName"
                        label="Last name*"
                        value={technician.lastName}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Input
                        name="email"
                        label="Email*"
                        value={technician.email}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="phone"
                        label="Phone number"
                        value={technician.phone}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Select
                        className="country-select"
                        valid={true}
                        isMulti={false}
                        label="Select country"
                        value={technician.country}
                        options={COUNTRIES}
                        onChange={(selectedOption) =>
                          onSelectChange('country', selectedOption)
                        }
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="city"
                        label="City"
                        value={technician.city}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <Input
                      name="address"
                      label="Address"
                      value={technician.address}
                      valid={true}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <Textarea
                      name="notes"
                      label="Additional notes"
                      value={technician.notes}
                      valid={true}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TechnicianAdd;
